import styled from 'styled-components';

const Svg = styled.svg`
    height: 24px;
    width: 24px;
`;

const Path = styled.path`
    transform-origin: center;
`;

export { Svg, Path };
